/**
 * This is the template document UID that is used for _all_ template documents.  It is special and is used
 * to determine if a document is, in fact, a template.
 */
export const NEW_PART_TEMPLATE_DOCUMENT_UID = "5304eee2-15ae-0a90-38bf-9b79b15ddf47";
export const externalUrls = {
    writeCodeDocs: "https://docs.flux.ai/reference/introduction",
    communitySlack: "https://join.slack.com/t/fluxcommunity/shared_invite/zt-p48n941f-wzQ06kGmuFJ2HXnGYT1JkA",
    genericsDocs: "https://docs.flux.ai/Introduction/generic-parts",
};
/**
 * Migrating domain-relevant strings here from the frontend package, which we can't access from core
 *
 * @todo move resources namespace to shared?
 */
export const documentStrings = {
    defaultProjectDescription: "Welcome to your new project. Imagine what you can build here.",
    defaultCodeWelcomeMessage: `// Howdy 👋.
//
// This is where you can create powerful part automations like resistors that tell you when too much current is flowing through them
// You can also create your own flexible parts, like generics (${externalUrls.genericsDocs})
//
// If you are new to writing code in Flux make sure to check out our get started docs: ${externalUrls.writeCodeDocs}
//
// We also have a Flux Slack Community in case you need help: ${externalUrls.communitySlack}
//
// To infinity and beyond 🚀`,
};
//# sourceMappingURL=constants.js.map